<template>
  <b-modal
    id="modal-create-ges"
    style="width: min-content; padding: 10px"
    hide-footer
    centered
    @hidden="resetModal"
    :noCloseOnBackdrop="getProcessing"
    :noCloseOnEsc="getProcessing"
    :hideHeaderClose="getProcessing"
  >
    <b-overlay :show="loading" rounded="sm">
      <template #overlay>
        <OverlayButton clase="overlay-md"> </OverlayButton>
      </template>
      <div
        class="row"
        style="
          /* width: min-content;
          margin-left: auto;
          margin-right: auto; */
          position: relative;
          z-index: 1;
        "
      >
        <div
          class="col-12 d-flex flex-column align-items-center modalsTables p-0"
          style="display: flex; justify-content: center"
        >
          <h3 class="pt-2 mb-4 font-weight-bold">{{ titleModalGes }}</h3>

          <p class="mb-5" v-if="!record">
            Asignale un tipo de GES, SVE y un nombre
          </p>
          <AlertComponent v-if="!record" />
          <div
            style="
              display: flex;
              justify-content: center;
              flex-direction: column;
              width: 100%;
            "
          >
            <b-tabs
              v-model="tabIndex"
              class="tabs-create-ges text-center"
              content-class="mt-5"
            >
              <b-tab title="Identifica el GES">
                <div class="mb-4 text-left">
                  <div class="pt-2">
                    <Select
                      label="Tipo de GES"
                      class="mb-5"
                      name="type_ges"
                      :options="optionsGES"
                      :value="formData.selectedGES"
                      v-model="formData.selectedGES"
                    />
                    <Select
                      label="Tipo de SVE"
                      name="sve"
                      class="mb-5"
                      :options="optionsSVE"
                      :value="formData.sve"
                      v-model="formData.sve"
                    />
                    <div class="">
                      <Input
                        label="Nombre del GES"
                        class="mb-5"
                        name="nameGES"
                        :value="formData.nameGES"
                        @input="
                          (event) => (formData.nameGES = event.target.value)
                        "
                      />
                    </div>
                  </div>
                </div>
              </b-tab>
              <b-tab :disabled="validGes === false" title="Agregar empleados">
                <div class="mb-5" v-if="usersNotExist.length > 0">
                  <b-alert
                    dismissible
                    variant="danger"
                    show
                    @dismissed="usersNotExist = []"
                  >
                    <p>Empleados que no estan registrados.</p>
                    <ul class="pl-1">
                      <li v-for="(error, index) in usersNotExist" :key="index">
                        <strong style="font-weight: bold !important"
                          >{{ error?.cc }} - {{ error?.name }}</strong
                        >
                      </li>
                    </ul>
                  </b-alert>
                </div>
                <div class="mb-5" v-if="notBelongUsers.length > 0">
                  <b-alert
                    dismissible
                    variant="danger"
                    show
                    @dismissed="notBelongUsers = []"
                  >
                    <p>Empleados que no estan dentro de la misma ubicación.</p>
                    <ul class="pl-1">
                      <li v-for="(error, index) in notBelongUsers" :key="index">
                        <strong style="font-weight: bold !important"
                          >{{ error?.cc }} - {{ error?.name }}</strong
                        >
                      </li>
                    </ul>
                  </b-alert>
                </div>
                <div>
                  <UploadFile @uploadFile="uploadFile" />
                </div>
                <div class="mb-5">
                  <v-select
                    class=""
                    placeholder=" Buscar empleado por nombre o cédula"
                    label="name_cc_sharp_id"
                    :options="employeesSearch"
                    v-model="employee"
                    @search="filterEmployees"
                    @input="addTempEmployee()"
                    :disabled="getProcessingEmployees || getProcessing"
                  >
                    <template slot="no-options">
                      No se encontró ningún trabajador
                    </template>
                  </v-select>
                </div>
                <div
                  class="mb-5 card-personalizada"
                  id="table_add_employee"
                  style="width: 100%"
                >
                  <div class="card-header card-header-left">
                    <h1
                      class="label-bold"
                      style="
                        line-height: inherit;
                        font-size: 16px;
                        color: #263238;
                        margin-bottom: 0px;
                      "
                    >
                      Personas relacionadas con el GES
                      <b-badge class="ml-2">Total: {{ total }}</b-badge>
                    </h1>
                  </div>
                  <div class="card-body w-100">
                    <div id="table_add_employee_into ">
                      <div class="">
                        <b-table
                          small
                          sticky-header
                          no-border-collapse
                          responsive
                          :busy="getProcessingEmployees"
                          :fields="fields"
                          :items="items"
                          head-variant="light"
                          class="col-12 mt-2 table-views"
                          show-empty
                        >
                          <template #table-busy>
                            <div class="text-center my-2 mb-3">
                              <OverlayButton></OverlayButton>
                            </div>
                          </template>
                          <template #empty>
                            <div class="text-center my-2">
                              <h2>Sin datos para mostrar</h2>
                            </div>
                          </template>
                          <template #cell(option)="row">
                            <button
                              class="p-2 button_delete_item"
                              :disabled="getProcessing"
                              @click.prevent="removeEmployee(row.item)"
                            >
                              <img
                                class="centerImg1 mr-1 resaltar icondelete"
                                :src="
                                  require('@/assets/images/icons/delete-bin-2-line.svg')
                                "
                              />
                            </button>
                          </template>
                        </b-table>
                      </div>
                      <div
                        class="col-12 cont-pagination my-0 d-flex justify-content-center"
                      >
                        <Pagination
                          :data="tablesPages"
                          :limit="10"
                          @pagination-change-page="loadRowsPag"
                        ></Pagination>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="mb-5 card-personalizada"
                  id="table_add_employee"
                  style="width: 100%"
                  v-if="employees_to_remove?.length > 0"
                >
                  <div class="card-header card-header-left">
                    <h1
                      class="label-bold"
                      style="
                        line-height: inherit;
                        font-size: 16px;
                        color: #263238;
                        margin-bottom: 0px;
                      "
                    >
                      Personas a eliminar del GES
                      <b-badge class="ml-2"
                        >Total: {{ employees_to_remove?.length }}</b-badge
                      >
                    </h1>
                  </div>
                  <div class="card-body w-100">
                    <div class="row" id="table_add_employee_into ">
                      <div class="">
                        <b-table
                          small
                          sticky-header
                          no-border-collapse
                          responsive
                          :fields="fields"
                          :items="employees_to_remove"
                          head-variant="light"
                          class="col-12 mt-2 table-views"
                          show-empty
                        >
                          <template #empty>
                            <div class="text-center my-2">
                              <h2>Sin datos para mostrar</h2>
                            </div>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="mb-5 card-personalizada"
                  id="table_add_employee"
                  style="width: 100%"
                  v-if="employeeNews?.length > 0"
                >
                  <div class="card-header card-header-left">
                    <h1
                      class="label-bold"
                      style="
                        line-height: inherit;
                        font-size: 16px;
                        color: #263238;
                        margin-bottom: 0px;
                      "
                    >
                      Personas para agregar al GES
                      <b-badge class="ml-2"
                        >Total: {{ employeeNews?.length }}</b-badge
                      >
                    </h1>
                  </div>
                  <div class="card-body">
                    <div class="row" id="table_add_employee_into ">
                      <div class="">
                        <b-table
                          small
                          sticky-header
                          no-border-collapse
                          responsive
                          :fields="fields"
                          :items="employeeNews"
                          head-variant="light"
                          class="col-12 mt-2 table-views"
                          show-empty
                        >
                          <template #empty>
                            <div class="text-center my-2">
                              <h2>Sin datos para mostrar</h2>
                            </div>
                          </template>
                          <template #cell(option)="row">
                            <button
                              class="p-2 button_delete_item"
                              :disabled="getProcessing"
                              @click.prevent="removeNewEmployee(row.item)"
                            >
                              <img
                                class="centerImg1 mr-1 resaltar icondelete"
                                :src="
                                  require('@/assets/images/icons/delete-bin-2-line.svg')
                                "
                              />
                            </button>
                          </template>
                        </b-table>
                      </div>
                    </div>
                  </div>
                </div>
              </b-tab>
            </b-tabs>
            <div class="row align-content-center justify-content-center">
              <div>
                <button
                  :disabled="
                    getProcessing ||
                    validGes === false ||
                    getProcessingEmployees
                  "
                  class="button_primary mr-4"
                  @click.prevent="saveGes()"
                >
                  <span>{{
                    record?.id ? "Guardar cambios" : "Guardar GES"
                  }}</span>
                  <b-spinner v-if="getProcessing" />
                </button>
              </div>
              <button
                class="button-secundary"
                :disabled="getProcessing"
                @click.prevent="$bvModal.hide('modal-create-ges')"
              >
                <span>Cancelar</span>
              </button>
            </div>
            <div class="mt-4" v-if="errors.length > 0">
              <b-alert
                dismissible
                v-for="(error, index) in errors"
                :key="index"
                show
                variant="danger"
              >
                {{ error }}
              </b-alert>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import useInputs from "@/components/general/Inputs";
const { Input, Select, Date } = useInputs();
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
import { mapState, mapActions, mapGetters } from "vuex";
import AlertComponent from "../components/AlertComponent.vue";
import UploadFile from "../components/UploadFile.vue";
import Pagination from "laravel-vue-pagination";

export default {
  components: {
    OverlayButton,
    Input,
    Select,
    Date,
    AlertComponent,
    UploadFile,
    Pagination,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    titleModalGes: {
      type: String,
      default: () => "",
    },
    optionsSVE: {
      type: Array,
      default: () => [],
    },
    record: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      tabIndex: 0,
      employee: null,
      formData: {
        selectedGES: null,
        sve: null,
        nameGES: "",
        file: null,
      },
      optionsGES: [
        { id: "administrative", name: "GES Administrativo" },
        { id: "operative", name: "GES Operativo" },
      ],
      fields: [
        {
          key: "nombre",
          label: "Nombre / C.C",
          sortable: false,
        },
        {
          key: "cargo",
          label: "Cargo",
          sortable: false,
        },
        {
          key: "area",
          label: "Área",
          sortable: false,
        },
        {
          key: "option",
          label: "",
          sortable: false,
        },
      ],
      items: [],
      employeesSearch: [],
      employeesIds: [],
      errors: [],
      notBelongUsers: [],
      usersNotExist: [],
      employees_to_remove: [],
      employeeNews: [],
      total: 0,
      page: 0,
      tablesPages: {},
    };
  },
  watch: {
    employeesBySearch() {
      const me = this;
      me.filterEmployeesSearch();
    },
    record() {
      const me = this;
      if (me.record) {
        me.formData = me.record;
        me.loadEmployeesById();
      }
    },
  },
  computed: {
    ...mapState("modOhAnalyst", ["employeesBySearch"]),
    ...mapGetters("htGes", [
      "getProcessingEmployees",
      "getIsSuccess",
      "getProcessing",
      "getErrors",
      "getEmployeesGES",
      "getUsersNotAdded",
    ]),
    validGes() {
      const me = this;
      return !!(
        me.formData.selectedGES &&
        me.formData.sve &&
        me.formData.nameGES
      );
    },
  },
  methods: {
    ...mapActions("modOhAnalyst", [
      "actGetEmployeeInfo",
      "actGetEmployeesBySearch",
    ]),
    ...mapActions("htGes", ["store", "indexEmployee", "editGes"]),
    ...mapActions("modSVE", ["actGetGESTableEmployees", "actEditGES"]),
    async saveGes() {
      const me = this;
      me.errors = [];
      me.notBelongUsers = [];
      me.usersNotExist = [];

      const formData = new FormData();
      if (me.formData.file) formData.append("file", me.formData.file);
      formData.append("name", me.formData?.nameGES);
      formData.append("code_type_ges", me.formData?.selectedGES?.id);
      formData.append("sve_id", me.formData?.sve?.id);

      if (me.record?.id) {
        const employees_to_remove = [];
        if (me.employeeNews.length > 0) {
          me.employeeNews.forEach((x) => {
            me.employeesIds.push(x.id);
          });
        }
        if (me.employees_to_remove.length > 0) {
          me.employees_to_remove.forEach((x) => {
            employees_to_remove.push(x.id);
          });
          formData.append("employees_to_remove", employees_to_remove);
        }
        formData.append("employees", me.employeesIds);
        formData.append("id", me.record.id);

        await me.editGes({ formData, id: me.record.id });
      } else {
        formData.append("employees", me.employeesIds);
        await me.store(formData);
      }

      if (me.getErrors) {
        if (me.getErrors?.response) {
          if (me.getErrors?.response?.data) {
            const { data } = me.getErrors?.response;
            if (data?.message) {
              if (data?.message?.employees)
                me.errors.push(data?.message?.employees[0]);
            }
          }
        } else {
          me.$bvToast.toast("Error en el servidor, vuelve a intentarlo", {
            title: "Error al crear GES",
            autoHideDelay: 3000,
            appendToast: true,
            variant: "danger",
            solid: true,
          });
        }
      }

      if (me.getIsSuccess) {
        me.$bvModal.hide("modal-create-ges");
        let messageModal = `Se ha creado correctamente el GES ${me.formData.nameGES}`;

        if (me.record?.id) {
          messageModal = "Los cambios han sido guardados.";
        }

        if (me.getUsersNotAdded) {
          const total =
            me.employeesIds.length +
            (me.getUsersNotAdded?.totalUsersInFile -
              me.getUsersNotAdded?.totalUsersNotAdded);
          messageModal = `Se ha ${
            me.record?.id ? "actualizado" : "creado"
          } correctamente el GES ${
            me.formData.nameGES
          } y se agregaron ${total} Empleados`;
        }
        me.$bvModal.show("modal-success");
        me.$emit("updateTable", me.formData.selectedGES.id, messageModal);
      }
    },
    filterEmployees(search, loading) {
      const me = this;
      loading(true);
      let data = {
        search: search,
      };
      me.actGetEmployeesBySearch(data).then(() => {
        loading(false);
      });
    },
    addTempEmployee() {
      const me = this;
      if (me.record?.id) {
        me.employeeNews.push({
          cargo: me.employee.position_name,
          nombre: `${me.employee.name} - ${me.employee.cc}`,
          area: me.employee.area_name,
          id: me.employee.id,
          isSave: me.employee.isSave,
        });
        if (me.employees_to_remove.length > 0) {
          const record = me.employees_to_remove.find(
            (x) => x.id === me.employee.id
          );
          if (record) {
            me.employees_to_remove.splice(
              me.employees_to_remove.indexOf(record),
              1
            );
          }
        }
      } else {
        me.items.push({
          cargo: me.employee.position_name,
          nombre: `${me.employee.name} - ${me.employee.cc}`,
          area: me.employee.area_name,
          id: me.employee.id,
          isSave: me.employee.isSave,
        });
        me.total = me.items.length;
      }

      me.employee = null;
      me.filterEmployeesSearch();
    },
    filterEmployeesSearch() {
      const me = this;
      me.employeesSearch = [];
      me.employeesIds = [];
      me.employeesSearch = [];
      me.employeesBySearch.forEach((x) => {
        if (
          !me.items.some((y) => y.id === x.id) &&
          !me.employeeNews.some((z) => z.id === x.id)
        ) {
          me.employeesSearch.push({
            ...x,
            isSave: me.getEmployeesGES.data.some((z) => z.employee_id === x.id),
          });
        }
      });
      if (!me.record?.id) {
        me.employeesIds = me.items.map((x) => {
          return x.id;
        });
      }
    },
    removeEmployee(item) {
      const me = this;

      const index = me.items.findIndex((x) => x.id === item?.id);
      me.items.splice(index, 1);
      if (item?.isSave) me.employees_to_remove.push(item);

      me.filterEmployeesSearch();
    },
    removeNewEmployee(item) {
      const me = this;
      if (me.record?.id) {
        const index = me.employeeNews.findIndex((x) => x.id === item?.id);
        me.employeeNews.splice(index, 1);
        me.items.push(item);
      }
      me.filterEmployeesSearch();
    },
    resetModal() {
      const me = this;
      me.tabIndex = 0;
      me.employeesSearch = [];
      me.employeesIds = [];
      me.items = [];
      me.errors = [];
      me.notBelongUsers = [];
      me.usersNotExist = [];
      me.employee = null;
      me.total = 0;
      me.page = 0;
      me.tablesPages = {};
      me.formData = {
        selectedGES: null,
        sve: null,
        nameGES: "",
      };
      me.employees_to_remove = [];
      me.employeeNews = [];
    },
    uploadFile(file) {
      const me = this;
      me.formData.file = file;
    },
    loadEmployeesById() {
      const me = this;
      let data = {
        id: me.record.id,
        page: me.page,
      };
      me.indexEmployee(data).then(() => {
        me.getEmployeesGES.data.forEach((x) => {
          me.items.push({
            cargo: x.charge,
            nombre: `${x.name} - ${x.cc}`,
            area: x.area,
            id: x.employee_id,
            isSave: true,
          });
        });
        me.total = me.getEmployeesGES.meta.total;
        me.tablesPages = me.getEmployeesGES;
      });
    },
    loadRowsPag(page = 1) {
      const me = this;
      me.page = page;
      me.loadEmployeesById();
    },
  },
};
</script>
<style lang="scss">
.button_primary {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}
.card_add_employee {
  display: flex;
  align-items: center;
  border: 1px solid #eceff1;
  border-radius: 8px;
  padding: 8px;
}
.card_add_employee button {
  border: none;
  background: #f6ffed;
  border-radius: 8px;
  color: #00761a;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  height: 40px;
  align-items: center;
}
.button_delete_item {
  border: none;
  background-color: white;
}
.card-personalizada {
  box-shadow: 0 0 0 0 transparent !important;
}

#modal-create-ges___BV_modal_body_ {
  padding: 20px !important;
  padding-top: 0px !important;
}
</style>
